// 🧿 طلسم محافظ فایل

import { useState, useEffect, useMemo } from "react";
// Common Components
import TabBox from "src/Components/Tabbox/TabBox";
import Button from "src/Components/Button";
// Local Components
import OrderTable from "./OrderTable";
import ErrorsTable from "./ErrorsTable";
import TradeTable from "./TradeTable";
import Program from "./Program";
// Hooks
import { useAppDispatch, useAppSelector } from "src/App/hooks";
// Types
import { MarketmakingTableTabs } from "src/Interfaces/marketmaking";
// Requests
import { getErrorsTable } from "src/Requests/automaticMarketMaking";
// Utilities
import { clearTaskRow, setTabIndex } from "src/Features/AutomaticMarketMaking/automaticMarketMakingSlice";
import { packetErrorHandler } from "src/Utils/requestUtils";

const TablesWrapper = () => {
  const tabIndex = useAppSelector(
    (store) => store.automaticMarketMaking.tabIndex
  );
  const taskTableClickedRowValues = useAppSelector(
    (store) => store.automaticMarketMaking.taskRow
  );
  const dispatch = useAppDispatch();

  // const setErrorCount = (count: number) => {
  //   localStorage.setItem("automaticMarketMakingErrorCount", count?.toString());
  // };

  // const getErrorCount = () =>
  //   parseInt(localStorage.getItem("automaticMarketMakingErrorCount") || "0");

  // const setSeenErrorCount = (count: number) => {
  //   localStorage.setItem(
  //     "automaticMarketMakingSeenErrorCount",
  //     count?.toString()
  //   );
  // };

  // const getSeenErrorCount = () =>
  //   parseInt(
  //     localStorage.getItem("automaticMarketMakingSeenErrorCount") || "0"
  //   );

  const [errorTableRefreshFlag, setErrorTableRefreshFlag] = useState(false);

  const [errorCount, setErrorCountState] = useState(() =>
    parseInt(localStorage.getItem("automaticMarketMakingErrorCount") || "0")
  );

  const [seenErrorCount, setSeenErrorCountState] = useState(() =>
    parseInt(localStorage.getItem("automaticMarketMakingSeenErrorCount") || "0")
  );

  // Sync localStorage + state
  const setErrorCount = (count: number) => {
    localStorage.setItem("automaticMarketMakingErrorCount", count.toString());
    setErrorCountState(count); // this triggers re-render
  };

  const setSeenErrorCount = (count: number) => {
    localStorage.setItem(
      "automaticMarketMakingSeenErrorCount",
      count.toString()
    );
    setSeenErrorCountState(count); // this triggers re-render
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchErrorsTable();
    }, 10000);
    return () => clearInterval(interval);
  }, [tabIndex]);

  function fetchErrorsTable() {
    const today = new Date().toISOString().split("T")[0];
    const errorDate = localStorage.getItem("automaticMarketMakingErrorDate");

    // If stored date is from a previous day, reset error count
    if (errorDate && errorDate !== today) {
      localStorage.removeItem("automaticMarketMakingErrorCount");
      localStorage.removeItem("automaticMarketMakingSeenErrorCount");
    }
    if (tabIndex === MarketmakingTableTabs.ErrorsTable)
      setErrorTableRefreshFlag(true);

    getErrorsTable({}, 0, 50)
      .then((res) => {
        const errors = res.count || 0;
        setErrorCount(errors);
        if (tabIndex === MarketmakingTableTabs.ErrorsTable)
          setSeenErrorCount(errors);

        // Store today's date
        localStorage.setItem("automaticMarketMakingErrorDate", today);
      })
      .catch(packetErrorHandler);
  }

  const errorTableAfterFetchHandler = () => {
    setSeenErrorCount(errorCount); //reset
    setErrorTableRefreshFlag(false);
  };

  const orderTradeTableSearchParam = useMemo(
    () => ({ taskId: taskTableClickedRowValues?.id }),
    [taskTableClickedRowValues?.id]
  );

  const getTable = () => {
    switch (tabIndex) {
      case MarketmakingTableTabs.Program:
        return <Program />;

      case MarketmakingTableTabs.OrderTable:
        return <OrderTable searchParam={orderTradeTableSearchParam} />;

      case MarketmakingTableTabs.TradeTable:
        return <TradeTable searchParam={orderTradeTableSearchParam} />;

      case MarketmakingTableTabs.ErrorsTable:
        return (
          <ErrorsTable
            getData={getErrorsTable}
            searchParams={orderTradeTableSearchParam}
            onFetchComplete={errorTableAfterFetchHandler}
            refreshFlag={errorTableRefreshFlag}
          />
        );
    }
  };

  const tabTable = () => {
    let list = [
      { index: MarketmakingTableTabs.OrderTable, title: "سفارشات" },
      { index: MarketmakingTableTabs.TradeTable, title: "معاملات" },
      {
        index: MarketmakingTableTabs.ErrorsTable,
        title: "خطا",
        count: errorCount - seenErrorCount,
      },
    ];
    if (taskTableClickedRowValues?.id)
      return [
        { index: MarketmakingTableTabs.Program, title: "تنظیمات ارسال" },
        ...list,
      ];

    return list;
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 border border-gray-300 rounded w-full p-3 h-full">
      <div className="flex items-center gap-3 ml-5">
        <TabBox
          activeTab={tabIndex}
          children={tabTable()}
          onChange={(_, index) => dispatch(setTabIndex(index))}
        />
        {taskTableClickedRowValues?.id && (
          <Button
            variant="outlined"
            text="نمایش همه"
            onClick={() => dispatch(clearTaskRow())}
          />
        )}
      </div>
      {getTable()}
    </div>
  );
};

export default TablesWrapper;
